<template>
    <div>
        <div class="grid-box-fc" style="padding-bottom: 10px;">
            <div class="grid-box-fc">
                <div class="sp-card">
                    <div class="title">总收款(元)</div>
                    <div class="mainNumber">{{element.payment}}</div>
                    <img class="img" src="../../../assets/p1.png" />
                </div>
                <div class="sp-card">
                    <div class="title">总退款(元)</div>
                    <div class="mainNumber">{{element.return}}</div>
                    <img class="img" src="../../../assets/p1.png" />
                </div>
                <div class="sp-card">
                    <div class="title">总收入(元)</div>
                    <div class="mainNumber">{{element.income}}</div>
                    <img class="img" src="../../../assets/p1.png" />
                </div>
                <div class="sp-card">
                    <div class="title">总支出(元)</div>
                    <div class="mainNumber">{{element.expend}}</div>
                    <img class="img" src="../../../assets/p1.png" />
                </div>
            </div>
            <div class="sp-card">
                <div id="pay5" style="width:100%;height:100%;">
                </div>
            </div>
        </div>
        <div class="grid-box-fc" style="grid-template-columns: 1fr 1fr 1fr 1fr;height: 420px;">
            <div class="sp-card">
                <div id="pay1" style="width:100%;height:100%;">
                </div>
            </div>
            <div class="sp-card">
                <div id="pay2" style="width:100%;height:100%;">
                </div>
            </div>
            <div class="sp-card">
                <div id="pay3" style="width:100%;height:100%;">
                </div>
            </div>
            <div class="sp-card">
                <div id="pay4" style="width:100%;height:100%;">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    props:{
        filterbox:{
            type:Object,
            default:()=>{
                return {};
            }
        }
    },
    data(){
        return{
            element:{
                expend:0,
                income:0,
                payment:0,
                return:0,
            },
            chartList:[null,null,null,null],
            isShowPage:false,
        }
    },
    methods:{
        setResize(){
            this.chartList.forEach(e=>{
                if(e){ e.resize(); }
            })
        },
        init:function(){
            this.isShowPage = true;
            this.getInfo();
        },
        close:function(){
            this.chartList.forEach(e=>{
                if(e&&(!e.isDisposed)){
                    e.dispose();
                }
            })
            this.isShowPage = false;
        },
        getMyChart:function(key){
            let myChart = this.chartList[key];
            if(!myChart){
                if(this.isShowPage){
                    myChart = echarts.init(document.getElementById('pay'+(key+1)));
                    this.chartList[key] = myChart;
                }
            }else{
                myChart.clear();
            }
            return myChart;
        },
        getInfo:function(){
            let obj = {};
            if(this.filterbox.time&&this.filterbox.time.length==2){
                obj.start = this.filterbox.time[0];
                obj.end = this.filterbox.time[1];
            }
            this.$api.getSumPayment({type:1,...obj}).then(res=>{
                let dd = res.data.data.data;
                if(dd&&dd.length>0){
                    this.element.payment = dd[0].value;
                    this.element.return = dd[1].value;
                    this.element.income = dd[2].value;
                    this.element.expend = dd[3].value;
                }else{
                    this.element.payment = 0;
                    this.element.return = 0;
                    this.element.income = 0;
                    this.element.expend = 0;
                }
            })
            this.$api.getNeedPayment({page:1,limit:10,column:'total',order:'desc',send:1,...obj}).then(res=>{
                let itemList = [];
                res.data.data.data.forEach(e => {
                    let obj = {
                        name:e.cname,
                        count:e.total,
                    }
                    itemList.unshift(obj);
                });
                let myChart = this.getMyChart(0);
                if(myChart){
                    let opt = this.getOption(itemList,0);
                    myChart.setOption(opt);
                }
            })
            this.$api.getNeedPayment({page:1,limit:10,column:'pay',order:'desc',send:1,...obj}).then(res=>{
                let itemList = [];
                res.data.data.data.forEach(e => {
                    let obj = {
                        name:e.cname,
                        count:e.pay,
                    }
                    itemList.unshift(obj);
                });
                let myChart = this.getMyChart(1);
                if(myChart){
                    let opt = this.getOption(itemList,1);
                    myChart.setOption(opt);
                }
            })
            this.$api.getNeedPayment({page:1,limit:10,column:'free',order:'desc',send:1,...obj}).then(res=>{
                let itemList = [];
                res.data.data.data.forEach(e => {
                    let obj = {
                        name:e.cname,
                        count:e.free,
                    }
                    itemList.unshift(obj);
                });
                let myChart = this.getMyChart(2);
                if(myChart){
                    let opt = this.getOption(itemList,2);
                    myChart.setOption(opt);
                }
            })
            this.$api.getNeedPayment({page:1,limit:10,column:'needPay',order:'desc',send:1,...obj}).then(res=>{
                let itemList = [];
                res.data.data.data.forEach(e => {
                    let obj = {
                        name:e.cname,
                        count:e.needPay,
                    }
                    itemList.unshift(obj);
                });
                let myChart = this.getMyChart(3);
                if(myChart){
                    let opt = this.getOption(itemList,3);
                    myChart.setOption(opt);
                }
            })
            this.$api.empAdvanceStatistic({page:1,limit:10,...obj}).then(res=>{
                let itemList = [];
                res.data.data.data.forEach(e => {
                    itemList.push({
                        name:e.e_name,
                        money:e.sumMoney,
                    })
                });
                let myChart = this.getMyChart(4);
                if(myChart){
                    let option = {
                        legend: {},
                        title:{
                            text:'员工预支',
                            left:'left',
                        },
                        color:[
                            '#B6A2DE',
                        ],
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'shadow'
                            }
                        },
                        grid: {
                            top: '20%',
                            left: '3%',
                            right: '3%',
                            bottom: '3%',
                            containLabel: true
                        },
                        xAxis: { type: 'category',data:itemList.map(e=>e.name)},
                        yAxis: {
                            type: 'value',
                            splitNumber:5,
                            // name: '单位:（元）',
                        },
                        series: [
                            { type: 'bar',data:itemList.map(e=>e.money)},
                        ]
                    }
                    myChart.setOption(option);
                }
            })
        },
        getOption:function(arr,index){
            let color = "";
            let title = "";
            if(index==0){
                color = "#2EC7C9";
                title = "总金额排行";
            }else if(index==1){
                color = "#3E77FA";
                title = "收款排行";
            }else if(index==2){
                color = "#FFB980";
                title = "免除排行";
            }else if(index==3){
                color = "#FF005A";
                title = "应收排行";
            }
            let option = {
                legend: {},
                title:{
                    text: title,
                    left:'left',
                },
                color:[
                    color,
                ],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                grid: {
                    top: '10%',
                    left: '3%',
                    right: '3%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    show:false,
                    // type: 'value',
                    // splitNumber:5,
                    // name: '单位:（元）',
                },
                yAxis: {
                    type: 'category',
                    data:arr.map(e=>e.name),
                    axisLabel:{
                        formatter:function(value){
                            var res = value;
                            if(res.length>3){
                                res = res.substring(0,2)+'...';
                            }
                            return res;
                        }
                    },
                },
                series: [
                    { type: 'bar',data:arr.map(e=>e.count)},
                ]
            };
            return option;
        }
    }
}
</script>

<style lang="scss" scoped>
.grid-box-fc{
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
}
</style>